import React from 'react'
import ReactDOM from 'react-dom'
import { HashRouter } from 'react-router-dom'
import './index.css'
import App from './App'
import { Provider } from 'react-redux'
import redux from './redux/store'
import * as serviceWorker from './serviceWorker'
import { IntlProvider } from 'react-redux-multilingual'
import translations from './i18n/fa/translations'
import { PersistGate } from 'redux-persist/integration/react'
import { ToastContainer } from 'react-toastify'

import './assets/scss/components/_toastify.scss'

const { store, persistor } = redux()

ReactDOM.render(
    <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
            <IntlProvider translations={translations}>
                <HashRouter>
                    <ToastContainer rtl position="top-right" />
                    <App />
                </HashRouter>
            </IntlProvider>
        </PersistGate>
    </Provider>,
    document.getElementById('root')
)

serviceWorker.unregister()
